import React, { useRef } from "react";
import classNames from "classnames";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import Textarea from "react-textarea-autosize";
import { SVGRepair } from "Constants/SVG";
import AlertWrapper from "ComponentsUI/AlertWrapper";
import { TextField } from "ComponentsUI/TextField";
import { SelectField } from "ComponentsUI/Selectfield";
import Button from "ComponentsUI/Button";
import { PlaceholderInput } from "ComponentsUI/Placeholderinput";

const useStyles = createUseStyles((theme) => ({
	root: {
		position: "relative",
		width: "400px",
		margin: "20px 0",
		padding: "20px 25px",
		border: `1px solid ${theme.palette.colors.cloudyBlue}`,
		borderRadius: "10px",
		backgroundColor: theme.palette.colors.white,
		fontFamily: theme.fonts.medium,
	},
	modalWrapper: {
		width: "348px",
		height: "auto",
		padding: "20px 15px",
		display: "flex",
		flexDirection: "row",
		position: "absolute",
		top: "-60px",
		left: "25px",
		border: `1px solid transparent`,
		background: theme.palette.colors.charcoalGrey,
		borderRadius: "12px",
	},
	modalIcon: {
		width: "30px",
		height: "30px",
	},
	modalTextWrapper: {
		textAlign: "left",
		margin: "0 10px",
	},
	modalHeader: {
		color: theme.palette.colors.white,
		lineHeight: "19.2px",
		fontFamily: theme.fonts.medium,
		marginBottom: "5px",
	},
	modalText: {
		fontSize: "14px",
		lineHeight: "16px",
		color: theme.palette.colors.grey,
		fontFamily: theme.fonts.light,
	},
	modalButtonClose: {
		width: "15px",
		height: "15px",
		display: "flex",
		justifyContent: "flex-end",
		color: theme.palette.colors.grey,
		cursor: "pointer",
	},
	headerText: {
		margin: "0 0 10px",
		textAlign: "center",
		color: theme.palette.colors.darkSlateBlue,
		fontFamily: theme.fonts.bold,
		fontSize: "22px",
		lineHeight: "26px",
	},
	labelWrapper: {},
	togglerWrapper: {
		display: "block",
		width: "45px",
		height: "25px",
		marginBottom: "15px",
		cursor: "pointer",
		position: "relative",
	},
	checkbox: {
		"&:checked + $togglerSlider": {
			backgroundColor: theme.palette.colors.purplishBlue,
			"&:before": {
				color: theme.palette.colors.black,
			},
		},
		"&:checked + $togglerSlider $togglerKnob": {
			left: "calc(100% - 19px - 3px)",
		},
	},
	togglerSlider: {
		backgroundColor: theme.palette.colors.grey,
		position: "absolute",
		borderRadius: "100px",
		top: "0",
		left: "0",
		width: "100%",
		height: "100%",
		transition: "all 300ms ease",
		"&:before": {
			content: "'Помощь Сhat GPT'",
			position: "absolute",
			top: "50%",
			left: "50px",
			transform: "translateY(-50%)",
			width: "230px",
			color: theme.palette.colors.oneMoreGrey,
			fontFamily: theme.fonts.light,
		},
	},
	togglerKnob: {
		position: "absolute",
		width: "calc(25px - 6px)",
		height: "calc(25px - 6px)",
		borderRadius: "50%",
		left: "3px",
		top: "3px",
		backgroundColor: "#fff",
		transition: "all 300ms ease",
	},
	TAWrapper: {
		position: "relative",
	},
	TAPlaceholder: {
		position: "absolute",
		top: "26%",
		left: "6%",
		color: theme.palette.colors.oneMoreGrey,
		fontFamily: theme.fonts.light,
	},
	textArea: {
		width: "100%",
		minHeight: "50px",
		marginBottom: "15px",
		padding: "20px",
		borderRadius: "10px",
		border: `solid 1px ${theme.palette.colors.disabled}`,
		resize: "none",
		backgroundColor: theme.palette.colors.white,
	},
	TAError: {
		marginBottom: 0,
		borderColor: theme.palette.colors.coralPink,
		animation: "blink .7s ease 2",
	},
	nameWrapper: {
		marginBottom: "15px",
	},
	providerWrapper: {
		marginBottom: "15px",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		root: {
			width: "380px",
		},
		modalWrapper: {
			width: "328px",
			top: "-75px",
		},
		textArea: {
			minHeight: "80px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			width: "300px",
		},
		modalWrapper: {
			width: "100%",
			top: "-75px",
			left: 0,
		},
		textArea: {
			minHeight: "160px",
		},
		TAPlaceholder: {
			top: "16%",
			left: "9%",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			width: "100%",
		},
		modalWrapper: {
			width: "100%",
			top: "-75px",
			left: 0,
		},
		TAPlaceholder: {
			top: "25%",
			left: "4%",
		},
		textArea: {
			minHeight: "100px",
		},
	},
}));

const AddReviewV2 = (props) => {
	const {
		textHeader,
		providersList,
		needHelper,
		reviewText,
		userName,
		reviewProvider,
		errors,
		text,
		selectProvidersPlaceholder,
		windowSizes,
	} = props;
	const classes = useStyles();
	const textareaRef = useRef(null);

	return (
		<div className={classes.root}>
			{needHelper && (
				<div className={classes.modalWrapper}>
					<div className={classes.modalIcon}>{SVGRepair}</div>
					<div className={classes.modalTextWrapper}>
						<div className={classes.modalHeader}>{text.repair_1}</div>
						<div className={classes.modalText}>{text.repair_2}</div>
					</div>
					<div className={classes.modalButtonClose}>
						<div onClick={() => props.changeNeedHelperHandler(false)}>
							<span className="icon24 icon-close" />
						</div>
					</div>
				</div>
			)}
			<h3 className={classes.headerText}>{textHeader}</h3>
			{/*<div className={classes.labelWrapper}>*/}
			<label className={classes.togglerWrapper}>
				<input
					type="checkbox"
					checked={needHelper}
					className={classes.checkbox}
					onChange={() => props.changeNeedHelperHandler(!needHelper)}
				/>
				<div className={classes.togglerSlider}>
					<div className={classes.togglerKnob} />
				</div>
			</label>
			{/*</div>*/}

			<AlertWrapper error={errors.reviewTextError}>
				<div className={classes.TAWrapper}>
					<PlaceholderInput placeholder={text.REVIEW} classNamePlaceholder={classes.TAPlaceholder}>
						<Textarea
							minRows={3}
							maxRows={3}
							onChange={(e) => props.changeReviewTextHandler(e)}
							value={reviewText}
							className={classNames(classes.textArea, {
								[classes.TAError]:
									errors.error && errors.reviewProviderError && !reviewText.trim().length,
							})}
						/>
					</PlaceholderInput>
				</div>
			</AlertWrapper>

			<div className={classes.nameWrapper}>
				<TextField
					autocomplete="name"
					name="name"
					onChange={(e) => props.changeUserNameHandler(e)}
					value={userName}
					placeholder={text.name_optional}
					greyPlaceholder={true}
				/>
			</div>
			<AlertWrapper error={errors.reviewProviderError}>
				<div className={classes.providerWrapper}>
					<SelectField
						equalBy="value"
						error={errors.error && !reviewProvider?.id && errors.reviewProviderError}
						windowSizes={windowSizes}
						allowInput={true}
						purplishBlueArrow={true}
						items={providersList || []}
						onItemSelect={(item) => {
							props.changeReviewProviderHandler(item);
						}}
						findItems={reviewProvider ? [reviewProvider] : []}
						text={text}
						placeholder={selectProvidersPlaceholder}
						activePlaceHolder={selectProvidersPlaceholder}
					/>
				</div>
			</AlertWrapper>
			<Button
				onClick={() => {
					props.sendReview();
				}}
				fullWidth={true}
				size="middle"
				status="purple"
			>
				{text.SEND_REVIEW}
			</Button>
		</div>
	);
};

AddReviewV2.propTypes = {
	providersList: PropTypes.array,
	needHelper: PropTypes.bool,
	reviewText: PropTypes.string,
	userName: PropTypes.string,
	reviewProvider: PropTypes.object,
	errors: PropTypes.object,
	selectProvidersPlaceholder: PropTypes.string,
	text: PropTypes.object.isRequired,
	windowSizes: PropTypes.object.isRequired,
	changeNeedHelperHandler: PropTypes.func,
	changeReviewTextHandler: PropTypes.func,
	changeUserNameHandler: PropTypes.func,
	changeReviewProviderHandler: PropTypes.func,
	sendReview: PropTypes.func,
};

AddReviewV2.defaultProps = {
	providersList: [],
	needHelper: false,
	reviewText: "",
	userName: "",
	selectProvidersPlaceholder: "",
	reviewProvider: {},
	errors: {},
	changeNeedHelperHandler: () => {},
	changeReviewTextHandler: () => {},
	changeUserNameHandler: () => {},
	changeReviewProviderHandler: () => {},
	sendReview: () => {},
};

export default AddReviewV2;
